import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, EventEmitter, Output } from '@angular/core';


import { Supervision,Flight } from 'solar-bo';
import { SolarBaseComponent } from '@solar/solar/solar-base/solar-base.component';
import { FlightListComponent } from '../flight-list/flight-list.component';
import { TabsetComponent } from 'ngx-bootstrap/tabs';




@Component({
  selector: 'app-flight-tab',
  templateUrl: './flight-tab.component.html',
  styleUrls: ['./flight-tab.component.scss']
})
export class FlightTabComponent extends SolarBaseComponent implements OnInit, OnChanges, AfterViewInit {
  
  @Input() supervision:Supervision;
  @Input() tabList:any[]=[];
  @Output() flightSelectedEvent = new EventEmitter<Flight>();
  @ViewChild("flightlist") flightlist: FlightListComponent;
  @ViewChild('tablistcomp') tablistComp: TabsetComponent;

  constructor() {
      super();
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {

  }

  ngAfterViewInit(){
    this.flightlist.showFlightImagesItemEvent.subscribe(item=>this.showFlightImagesItemEventHandler(item));
  }

  removeTabHandler(tab){
    this.tabList.splice(this.tabList.indexOf(tab), 1);
    console.log('Remove Tab handler');
  }

  showFlightImagesItemEventHandler(newFlight:Flight){

    let tabz=this.tabList.find(tab=>tab.flight.id==newFlight.id);
    console.log(this.tablistComp.tabs.length);
    if (!tabz){
      tabz={flight:newFlight,removable:true};
      this.tabList.push(tabz);
      let idx=this.tabList.length-1;
      setTimeout(() => {
        let taborg=this.tablistComp.tabs[idx+1];
        taborg.active=true;
        taborg['flightid']=newFlight.id;
      });
    }
    else{
      let taborg=this.tablistComp.tabs.find(tab=>tab['flightid']==newFlight.id);
      if (taborg){
        taborg.active=true;
      }
    }
  }

  flightSelectedEventHandler($event){
    this.flightSelectedEvent.emit($event);
  }

}

